/**
 * @Project Name: vue-admin
 * @Author: luichooy
 * @Date: 2018-01-17 15:01
 * @Email: luichooy@163.com
 * @Idea: WebStorm
 */





// 作为main组件子页面展示  但不在左侧菜单显示的路由卸载otherRoter里
let routers = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '桂软产品'
    },
    component: () => import('src/pages/index')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('src/pages/login')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('src/pages/register')
  },
  {
    path: '/findpass',
    name: 'findpass',
    component: () => import('src/pages/findpass')
  },
  {
    path: '/myuserInfo',
    name: 'myuserInfo',
    component: () => import('src/pages/myuserInfo')
  },
  {
    path: '/myeditPass',
    name: 'myeditPass',
    component: () => import('src/pages/myeditPass')
  },
  {
    path: '/404',
    name: '404',
    meta: {
      title: '路由错误'
    },
    component: () => import('src/pages/404')
  },


];

// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里



export default routers;


// WEBPACK FOOTER //
// ./src/router/route.js